import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Init_des } from '../../components/Javascript/Init_des'
export const E2 = props => {
  return (
    <>
      <Init_des
      title="SOCIOTHON"
      date=" December 29, 2020 - January 03, 2021"
      extra=" Students Participated: Around 500"
        p1="Sociothon, a social case competition conducted by team Unnat Bharat Abhiyan, IIT Roorkee between December 29, 2020 to January 03, 2021 aims to nurture and foster critical thinking skills in order to weed out various social ills.

        Under Sponsorship of Srijan Ka Sankalp (iShaksham), participants were called from first year undergraduates in teams comprising of three to four students. Teams were given a problem statement describing the social menace.
        
        Competition consisted of two rounds the preliminary round and the final round. Teams registered formed by approximately 500 students were called to submit a one pager abstract of their solution of case study in preliminary round.
        
        The final round was a live presentation before judge Shashwat Gangwal (founder of iShaksham). Total 8 teams were selected for final round after short out from more than 100 teams by a panelist team. 
        Three winner teams were shortlisted by judge in final round of the event which are as follows:"

        p2="3rd: Socio-ARKS &nbsp;

        2nd: Abhyuday &nbsp;
        
        1st: White Tiger &nbsp;"

        p3="Winner teams were awarded with cash prizes and an internship offer for each member of winning teams from iShaksham."
      />
    </>
  )
}
